import gql from 'graphql-tag';

export const listEquipments = gql `
  query listEquipments($vendorIds: [String]) {
    listEquipments(vendorIds: $vendorIds) {
      equipments {
        equipmentId
        equipmentName
        equipmentType
        equipmentVendorId
        equipmentVendorName
        isBookingSupported
        timezone
        shippingZone
        country
      }
      vendorIds
    }
  }
`;